import { useContext, useEffect } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { Box, Drawer, Hidden } from "@mui/material";
import { styled } from "@mui/material/styles";
import SidebarMenu from "./SidebarMenu";
import { SidebarContext } from "../../../contexts/SidebarContext";
import Logo from "../../../shared/components/logo";
import useLazyQuery from "../../../shared/components/hooks/useLazyQuery";
import useMutation from "../../../shared/components/hooks/useMutation";
import { clearLocalStorageData } from "../../../shared/utils/localStorage";

const SidebarWrapper = styled(Box)(
  ({ theme }) => `
        width: ${theme.sidebar.width};
        color: ${theme.sidebar.textColor};
        background: ${theme.sidebar.background};
        height: 100%;
        padding-bottom: 11%;
        box-shadow: ${theme.sidebar.boxShadow};
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            position: fixed;
            z-index: 10;
           
        }
`
);

const TopSection = styled(Box)(
  ({ theme }) => `
        display: flex;
        height: 13%;
        align-items: center;
        margin:  ${theme.spacing(4)} ${theme.spacing(2)};
        
`
);

function Sidebar() {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const closeSidebar = () => toggleSidebar();

  const { data: permissions, fetchData } = useLazyQuery("admin/user/permissions");
  const { modifyData } = useMutation();

  useEffect(() => {
    fetchData();
  }, []);

  const handleLogout = async () => {
    let response = await modifyData(`/user/logout`, "post");
    if (response) {
      window.location.href = "/login";
      clearLocalStorageData();
    }
  };

  return (
    <>
      <Hidden lgDown>
        <SidebarWrapper>
          <TopSection>
            <Logo />
          </TopSection>
          <Scrollbars autoHide>
            <SidebarMenu userData={(permissions as any)?.data} />
          </Scrollbars>
          {/* <SidebarFooter onLogout={handleLogout} /> */}
        </SidebarWrapper>
      </Hidden>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          open={sidebarToggle}
          onClose={closeSidebar}
          variant="temporary"
          elevation={9}
        >
          <SidebarWrapper>
            <Scrollbars autoHide>
              <TopSection>{/* <Logo /> */}</TopSection>
              <SidebarMenu />
            </Scrollbars>
          </SidebarWrapper>
        </Drawer>
      </Hidden>
    </>
  );
}

export default Sidebar;
